import { useOnMount } from '@app/hooks/lifecycle';

const ExternalRedirect = ({ to }: { to: string }) => {
  useOnMount(() => ((window as Window).location = to));

  return (
    <div>
      If your browser does not redirect you automatically please click{' '}
      <a href={to}>here</a>
    </div>
  );
};

export default ExternalRedirect;
